import { useState } from "react";
import Dropdown from "../../../components/form/Dropdown";
import TextField from "../../../components/form/TextField";
import { useGetVideosQuery } from "../../../features/videos/videosAPI";
import {
  useAddQuizMutation,
  useEditQuizMutation,
} from "../../../features/quizzes/quizzesAPI";
import { useEffect } from "react";
import ErrorMessage from "../../ui/ErrorMessage";
import { useNavigate } from "react-router";

function QuizForm({ initialData }) {
  const navigate = useNavigate();

  const [formValues, setFormValues] = useState({});
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [optionList, setOptionList] = useState([
    { id: 1, option: "", isCorrect: false },
  ]);
  const {
    data: videos,
    isLoading: isVideosLoading,
    isError: isVideosError,
  } = useGetVideosQuery();

  const [
    addQuiz,
    { isLoading: addLoading, isError: addError, isSuccess: addSuccess },
  ] = useAddQuizMutation();
  const [
    editQuiz,
    { isLoading: editLoading, isError: editError, isSuccess: editSuccess },
  ] = useEditQuizMutation();

  function handleChange(event) {
    const { name, value } = event.target;
    setFormValues({ ...formValues, [name]: value });
  }

  function handleSubmit(event) {
    event.preventDefault();
    const video_id = Number(formValues.video);

    const video_title = videos?.find((video) => video.id === video_id)?.title;
    delete formValues.video;

    const payload = {
      ...formValues,
      video_id: video_id,
      video_title: video_title,
      options: optionList,
    };

    if (initialData?.id) {
      editQuiz({ id: initialData.id, data: payload });
    } else {
      addQuiz(payload);
    }
  }

  function handleOptions(index, name, value) {
    let list = [...optionList];
    list[index] = { ...list[index], [name]: value };
    setOptionList(list);
  }
  function handleRowDelete(index) {
    const list = [...optionList];
    list.splice(index, 1);
    setOptionList(list);
  }

  function addNewOption(event) {
    event.preventDefault();
    setOptionList([
      ...optionList,
      {
        id: optionList.length + 1,
        option: "",
        isCorrect: false,
      },
    ]);
  }

  useEffect(() => {
    if (Object.keys(initialData).length > 0) {
      setFormValues({ ...initialData, video: initialData.video_id });
      setOptionList([...initialData?.options]);
    }
  }, [initialData]);

  useEffect(() => {
    if (addSuccess || editSuccess) {
      navigate("/admin/quizzes");
    }
    if (editError || addError) {
      setShowErrorMessage(true);
    }
  }, [addError, addSuccess, editError, editSuccess, navigate]);

  let form = null;
  if (isVideosLoading) form = "Preparing Form...";
  else if (isVideosError) form = "Something went wrong!";
  else
    form = (
      <form className="space-y-6" onSubmit={handleSubmit}>
        <TextField
          id="question"
          label="Question"
          type="text"
          onChange={handleChange}
          value={formValues.question}
        />
        <Dropdown
          id="video"
          label="Video"
          options={videos}
          labelID="title"
          value={formValues.video}
          onChange={handleChange}
          required
        />
        {optionList?.map((option, index) => {
          return (
            <div
              key={index}
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 20,
                width: "100%",
              }}
            >
              <TextField
                id="option"
                label={`Option - ${index + 1}`}
                type="text"
                onChange={(e) => handleOptions(index, "option", e.target.value)}
                value={option.option}
              />
              <div className="d-flex flex-row">
                <input
                  type="checkbox"
                  id="isCorrect"
                  name="isCorrect"
                  checked={option.isCorrect}
                  onChange={(e) =>
                    handleOptions(index, "isCorrect", !option.isCorrect)
                  }
                />
                <label htmlFor="isCorrect" style={{ marginLeft: 10 }}>
                  Is Correct
                </label>
              </div>
              <span
                className=" cursor-pointer"
                onClick={() => {
                  handleRowDelete(index);
                }}
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="#aa1111"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M17 5V4C17 2.89543 16.1046 2 15 2H9C7.89543 2 7 2.89543 7 4V5H4C3.44772 5 3 5.44772 3 6C3 6.55228 3.44772 7 4 7H5V18C5 19.6569 6.34315 21 8 21H16C17.6569 21 19 19.6569 19 18V7H20C20.5523 7 21 6.55228 21 6C21 5.44772 20.5523 5 20 5H17ZM15 4H9V5H15V4ZM17 7H7V18C7 18.5523 7.44772 19 8 19H16C16.5523 19 17 18.5523 17 18V7Z"
                    fill="#dd1111"
                  />
                  <path d="M9 9H11V17H9V9Z" fill="#dd1111" />
                  <path d="M13 9H15V17H13V9Z" fill="#dd1111" />
                </svg>
              </span>
            </div>
          );
        })}
        <button
          className="btn btn-secondary"
          onClick={addNewOption}
          type="button"
        >
          Add More Option
        </button>
        {/* <div className="d-flex align-center">
          <input type="checkbox" id="isCorrect" name="isCorrect" value={true} />
          <label htmlFor="isCorrect" style={{ marginLeft: 10 }}>
            Correct
          </label>
        </div> */}
        {showErrorMessage && <ErrorMessage />}
        <div
          style={{
            display: "grid",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <button
            type="submit"
            className="btn btn-primary"
            style={{
              padding: "0.5rem 2rem",
              marginTop: "0.5rem",
              width: "fit-content",
            }}
            disabled={addLoading || editLoading}
          >
            Save
          </button>
        </div>
      </form>
    );

  return form;
}

export default QuizForm;
